import type { DocumentNodeWithDetailsDto } from '@monorepo/shared';
import { DocumentStatus } from '@monorepo/shared';

export type StatusFilter = 'all' | DocumentStatus;

export interface DocumentRowActions {
  onOpen: (nodeId: string) => void;
  onRename: (node: DocumentNodeWithDetailsDto) => void;
  onDelete: (node: DocumentNodeWithDetailsDto) => void;
  onDiffuse: ((doc: DocumentNodeWithDetailsDto) => void) | undefined;
  onResend: ((doc: DocumentNodeWithDetailsDto) => void) | undefined;
  onSendForValidation: ((doc: DocumentNodeWithDetailsDto) => void) | undefined;
  onValidate: ((doc: DocumentNodeWithDetailsDto) => void) | undefined;
  onReject: ((doc: DocumentNodeWithDetailsDto) => void) | undefined;
  onUploadNewVersion: ((doc: DocumentNodeWithDetailsDto) => void) | undefined;
  onArchive: ((doc: DocumentNodeWithDetailsDto) => void) | undefined;
  onShowReaders: ((doc: DocumentNodeWithDetailsDto) => void) | undefined;
}

export interface DocumentRowPermissions {
  canRename: boolean;
  canDelete: boolean;
  canDiffuse: boolean;
  canSendForValidation: boolean;
  canValidate: boolean;
  canUploadNewVersion: boolean;
  canArchive: boolean;
}

export interface StatusBadgeConfig {
  label: string;
  className: string;
}

export const statusBadgeConfig: Record<DocumentStatus, StatusBadgeConfig> = {
  [DocumentStatus.DRAFT]: {
    label: 'documents.table.status.not_started',
    className: 'bg-gray-100 text-gray-600',
  },
  [DocumentStatus.PENDING_VALIDATION]: {
    label: 'documents.table.status.pending_validation',
    className: 'bg-orange-100 text-orange-700',
  },
  [DocumentStatus.VALIDATED]: {
    label: 'documents.table.status.validated',
    className: 'bg-green-100 text-green-700',
  },
  [DocumentStatus.DIFFUSED]: {
    label: 'documents.table.status.diffused',
    className: 'bg-blue-100 text-blue-700',
  },
  [DocumentStatus.REJECTED]: {
    label: 'documents.table.status.rejected',
    className: 'bg-red-100 text-red-700',
  },
  [DocumentStatus.ARCHIVED]: {
    label: 'documents.table.status.archived',
    className: 'bg-gray-100 text-gray-500',
  },
};
